import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '../../@types/ApiResponse';
import type { Branch } from '../../@types/Branch';
import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import { getJSON } from '../../fetch';
import useAuth from '../../hooks/useAuth';

export const BRANCHES_QUERY = '/api/organisation/branches';

const useBranches = (): [Branch[] | undefined, RequestStateQuery] => {
  const { decodedToken, getToken } = useAuth();

  const belongsToBranchExist = decodedToken?.['belongs-to-branch']
    ? typeof decodedToken['belongs-to-branch'] === 'string'
      ? !!decodedToken['belongs-to-branch']
      : !!decodedToken['belongs-to-branch'].length
    : false;

  const { data, isLoading, isSuccess, isError } = useQuery<ApiResponse<Branch[]>>({
    queryKey: [BRANCHES_QUERY, decodedToken?.sub],
    queryFn: async () =>
      await getJSON<ApiResponse<Branch[]>>('/api/organisation/branches', getToken()!),
    enabled: !!belongsToBranchExist,
  });

  return [data?.response, { isLoading, isSuccess, isError }];
};

export default useBranches;
